import { render } from "./TutorMessage.vue?vue&type=template&id=1c9911f3&scoped=true"
import script from "./TutorMessage.vue?vue&type=script&lang=js"
export * from "./TutorMessage.vue?vue&type=script&lang=js"

import "./TutorMessage.vue?vue&type=style&index=0&id=1c9911f3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9911f3"]])

export default __exports__